<template>
    <div>
        <div class="mb-3">
            <BackButton :to="__('navigation.invitations')"/>
        </div>

        <div class="card card-custom">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">{{ __('general.invitation') }}</h3>
                    <p>
                        Edit the selected invitation.
                    </p>
                </div>
            </div>
            <div class="card-body">
                <h2 class="mb-4">{{ __('user.account_and_profile') }}</h2>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ __('user.email') }}</label>
                            <input v-model="formData.email" type="email" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ __('user.phone') }}</label>
                            <input v-model="formData.phone" type="text" class="form-control">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="exampleSelect1">{{ __('user.role') }}</label>
                            <select v-model="formData.role_id" class="form-control" id="exampleSelect1">
                                <option v-for="(roleName, roleId) in roles"
                                        :value="roleId"
                                        :selected="roleId === invitation.role_id">
                                    {{ __('roles.' + roleName) }}
                                </option>
                            </select>
                            <span class="form-text text-muted">{{ __('store.select_role') }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button class="btn btn-primary" :disabled="!valuesHaveChanged" @click="saveInvitationData">
                    <i class="fas fa-save mr-1"/>
                    {{ __('actions.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";

export default {
    components: {BackButton},
    props: {
        invitation: Object,
        roles: Object
    },

    data() {
        return {
            formData: {
                email: null,
                phone: null,
                role_id: null
            }
        }
    },

    mounted() {
        this.formData.email = this.invitation.email
        this.formData.phone = this.invitation.phone
        this.formData.role_id = this.invitation.role_id
    },

    methods: {
        saveInvitationData() {
            this.$inertia.patch(this.$route('users.invitations.update', [this.invitation.id]), this.formData)
        }
    },

    computed: {
        valuesHaveChanged() {
            return this.invitation.email !== this.formData.email
                || this.invitation.phone !== this.formData.phone
                || this.invitation.role_id !== this.formData.role_id
        }
    }
}
</script>
